import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import SelectSearchLayout from '../../../layouts/select-search'
import { userOperations } from '../../../../state/ducks/users'
import { connect } from 'react-redux'
import * as PropTypes from 'prop-types'
import { ClientShape } from '../../../../prop-types'
import { Session } from '../../../../state/utils/session'

class GroupUsersForm extends Component {
  constructor (props) {
    super(props)

    // set state
    this.state = {
      session: new Session()
    }

    // handlers
    this.returnOptions = this.returnOptions.bind(this)
    this.onUserSarchKeywordChange = this.onUserSarchKeywordChange.bind(this)
    this.onSelectUser = this.onSelectUser.bind(this)
    this.removeUser = this.removeUser.bind(this)
  }

  returnOptions () {
    const options = []
    this.props.users_list.forEach(element => {
      const groupAdded = this.props.added_users.find(p => p.toString() === element.id.toString())
      if (!groupAdded) {
        options.push({
          value: element.id + '|' + element.username,
          label: element.username
        })
      }
    })
    return options
  }

  onUserSarchKeywordChange (keyword) {
    this.returnOptions()
    this.props.fetchUsers({ search: keyword })
  }

  onSelectUser (item) {
    const addedUsers = this.props.added_users
    const split_ = item.value.split('|')
    addedUsers.push({
      id: split_[0],
      username: split_[1]
    })
    this.props.onChange(addedUsers)
  }

  removeUser (index) {
    const addedUsers = this.props.added_users
    addedUsers.splice(index, 1)
    this.props.onChange(addedUsers)
  }

  renderGroups () {
    return (
            <>
                <table className="table">
                    <tbody>
                    {
                        this.props.added_users.map((user, index) => {
                          return (
                                <tr key={index} className="border">
                                    <td style={{ width: '20px' }}>
                                        <i className="fa fa-object-group fa-2x"></i>
                                    </td>
                                    <td>
                                        <small className="font-w400">{user.username}</small>
                                        <div className="font-w400 text-muted">
                                            <small>---</small>
                                        </div>
                                    </td>
                                    <td style={{ width: '20px' }}>
                                        <Button
                                            variant="danger"
                                            className="float-right"
                                            onClick={this.removeUser.bind(this, index)}
                                        >
                                            <i className="fa fa-trash"/>
                                        </Button>
                                    </td>
                                </tr>
                          )
                        })
                    }
                    </tbody>
                </table>
                {/* <pre> */}
                {/*    <code className="json"> */}
                {/*        {JSON.stringify(this.props.added_users)} */}
                {/*    </code> */}
                {/* </pre> */}
            </>
    )
  }

  render () {
    return (
            <>
                <div className="form-group">
                    <div className="col-sm-6 col-sm-offset-3">
                        <div className="form-material">
                            <SelectSearchLayout
                                getOptions={this.returnOptions}
                                onSearchChange={this.onUserSarchKeywordChange}
                                onSelectItem={this.onSelectUser}
                            />
                            <label htmlFor="input-groups">Search users</label>
                        </div>
                        {this.renderGroups()}

                    </div>
                </div>
            </>
    )
  }
}

// Set propTypes
GroupUsersForm.propTypes = {
  users_list: PropTypes.arrayOf(ClientShape).isRequired,
  fetchUsers: PropTypes.func.isRequired
}

// Set defaultProps
GroupUsersForm.defaultProps = {
  users_list: [],
  added_users: [],
  onChange: () => {
  }
}

// mapStateToProps
const mapStateToProps = (state) => ({
  users_list: state.users.fetchUsersReducer.data.results
})

// mapStateToProps
const mapDispatchToProps = {
  fetchUsers: userOperations.list
}

// Export Class
const _GroupUsersForm = connect(mapStateToProps,
  mapDispatchToProps)(GroupUsersForm)
export { _GroupUsersForm as GroupUsersForm }
